import React, { Component } from 'react'
import { connect } from 'react-redux'
import swal from 'sweetalert'
import axios from 'axios'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from "../../../functions/getServerURL"

import { Button, FormGroup, FormControl, ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-16-bootstrap-date-picker'

import MetadataOverviewField from './MetadataOverviewField'

class OverviewField extends Component {

  state = {
    editMode: false,
    editableText: this.props.text || "",
    editableArray: this.props.array || [],
  }

  _renderMenuItemChildren = (option, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON CLIENT CONTACT SELECTION
    return [
      <div key="name" search={props.text}>
        <strong>{option.first_name} {option.last_name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {option.email ? option.email : "N/A"}
        </small>
      </div>,
    ]
  }

  handleChange = (e) => {
    if(this.props.dataType === "rduid") {
      const containsSpecialChars = /[^a-zA-Z0-9]/.test(e.target.value)
      if(!containsSpecialChars) {
        this.setState({ editableText: e.target.value })
      }
    } else {
      this.setState({ editableText: e.target.value })
    }
  }

  handleDateChange = (date, formattedDate) => {
    this.setState({ editableText: formattedDate })
  }

  handleEditableArrayChange = (value) => this.setState({editableArray: value})

  getValidationState = () => {
    /// COLORS THE INPUT FIELD BASED ON THE LENGTH OF THE TEXT
    const length = this.state.editableText.length;
    if (length > 0) return 'success';
    else if (length === 0) return 'error';
    return null;
  }

  handleEditClick = () => {
    this.setState({editMode: true})
  }

  handleCancelClick = () => {
    this.setState({
      editMode: false,
      editableText: this.props.text,
      editableArray: this.props.array,
    })
  }

  handleSaveClick = () => {
    const { dataType, project, array } = this.props
    let { editableText, editableArray } = this.state

    let updatedValue

    if (array && dataType === 'metadata_values') {
      // see comments in the function called on the next line
      return this.handleSaveMetadataValues()
    } else if (array) {
      updatedValue = editableArray
    } else if (dataType === 'start_date' || dataType === 'completion_date' || dataType === 'target_end_date') {
      if (editableText) {
        const date = this.generateFormattedDate(editableText)
        updatedValue = new Date(date).toJSON().split("T")[0]
      } else {
        updatedValue = null
      }
    } else {
      updatedValue = editableText
    }
    if(dataType === 'rduid' && !updatedValue) return
    this.setState({ editMode: false }, () => {
      return this.props.editProject(dataType, updatedValue, project.url)
    })
  }


  generateFormattedDate = (date) => {
    date = date.split("-")
    const year = parseInt(date[2], 10)
    const month = parseInt(date[0], 10) - 1
    const day = parseInt(date[1], 10)
    return new Date(year, month, day).toISOString()
  }



  handleSaveMetadataValues = () => {
    const { metadataType, metadataValues, dataType, project } = this.props
    const { editableArray, editableText } = this.state
    const type = metadataType.type.toLowerCase()
    let updatedMetadataValues = metadataValues

    if (type === 'selectable options' || type === 'user') {
      // 'selectable options' and 'user' type metadata function as simple many to many relationships
      const filteredValues = metadataValues.filter(val => val.metadata !== metadataType.url)

      updatedMetadataValues = [...filteredValues, ...editableArray]

    } else if (type === 'number' || type === 'date' || type === 'text') {
      // since 'number', 'date', and 'text' type metadata are handled differently

      // first try to find the metadata value for the project (projects should only have one metadata_value for each metadata of type 'number'm 'date', or 'text' to make them more like normal inputs)
      let metadataValue = metadataValues.find(val => val.metadata === metadataType.url)

      if (!!metadataValue && editableText === metadataValue[type]) {
        // if the project already has a metadata value of the selected metadata type and its date or number or text value is the same (ie: it unchanged), set the updated metadata values array to the existing project metadata values (we'll save the project as it already is)
        updatedMetadataValues = metadataValues

      } else if (!!metadataValue) {
        // if a project has a metadata value of the selected metadata and its date, number or text is different, we want to send a patch request for that metadata value with the updated date, number or text

        return this.editMetadataValue(metadataValue)

      } else {
        //  if a project DOES NOT have a metadata value of the selected metadata, we create a new value, in the createNewMetadataValue() function, and then run the editProject() function with the newly created metadata value + the old values saved as the project metadata values
        return this.createNewMetadataValue()
      }
    }

    // if we have not run either the editMetadataValue() or createNewMetadataValue() function, run the editProject() function from the reducer
    return this.props.editProject(dataType, updatedMetadataValues, project.url)
  }


  editMetadataValue = (metadataValue) => {
    // This function is for editing text type metadata options, since free text values will likely be unique to a project there is no reason to create a new one every time the value is updated. Updating a project's only metadata_value of the particular text type keeps the database from getting cluttered

    const { metadataType, metadataValues, dataType, project } = this.props
    const { editableText } = this.state

    let date = null
    let number = null
    let text = null

    const type = this.props.metadataType.type.toLowerCase()

    if (type === 'date') {
      date = new Date(editableText).toJSON().split("T")[0]
    } else if (type === 'number') {
      number = editableText
    } else if (type === 'text') {
      text = editableText
    } else {
      return
    }

    swal({
      text: "Editing the project... Please stand by.",
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })

    return axios({
      method: "PATCH",
      url: metadataValue.url,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
      data: {
        date,
        number,
        text,
      }
    })
    .then(response => {
      const filteredMetadataValues = metadataValues.filter(val => val.metadata !== metadataType.url)

      const updatedMetadataValues = [...filteredMetadataValues, response.data]

      return this.props.editProject(dataType, updatedMetadataValues, project.url)
    })
    .catch(error => {
      const message = "There was an error editing your project"
      return handleErrorFetchingData(error, message)
    })

  }


  createNewMetadataValue = () => {
    // This function creates a new metadata_value for metadata of type date or number if one does not exist. This hides the fact that these are not standard date and number inputs

    const { metadataType, metadataValues, dataType, project } = this.props
    const { editableText } = this.state

    let date = null
    let number = null
    let text = null

    const type = this.props.metadataType.type.toLowerCase()

    if (type === 'date') {
      date = new Date(editableText).toJSON().split("T")[0]
    } else if (type === 'number') {
      number = editableText
    } else if (type === 'text') {
      text = editableText
    } else {
      return
    }

    swal({
      text: "Editing the project... Please stand by.",
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })

    return axios({
      method: "POST",
      url: `${getServerURL()}metadata-values/`,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
      data: {
        created_by: this.props.currentUser,
        date,
        number,
        text,
        option: null,
        user: null,
        metadata: this.props.metadataType.url,
      }
    })
    .then(response => {
      const filteredMetadataValues = metadataValues.filter(val => val.metadata !== metadataType.url)

      const updatedMetadataValues = [...filteredMetadataValues, response.data]

      return this.props.editProject(dataType, updatedMetadataValues, project.url)
    })
    .catch(error => {
      const message = "There was an error editing your project"
      return handleErrorFetchingData(error, message)
    })
  }



  ///////////////////// IF EDITING A FIELD //////////////////////
  renderEditForm = () => {

    const { dataType } = this.props

    ////////////////////  SHORT DESCRIPTION EDITING  ////////////////////
    if (dataType === "title" || dataType === "directory") {
      return (
        <FormGroup
        validationState={this.getValidationState()}
        style={{width:"75%", display:"inline-block"}}
        >
          <FormControl
            className="short-description"
            type="text"
            value={this.state.editableText}
            onChange={this.handleChange}
          />
        </FormGroup>
      )
    ////////////////////  SHORT DESCRIPTION EDITING  ////////////////////
    } else if (dataType === "rduid") {
      return (
        <FormGroup
        validationState={this.getValidationState()}
        style={{width:"75%", display:"inline-block"}}
        >
          <FormControl
            className="short-description"
            placeholder="This field is mandatory. Please input a Revenue Dashboard Unique Identifier."
            type="text"
            value={this.state.editableText.toUpperCase()}
            onChange={this.handleChange}
          />
        </FormGroup>
      )
      ////////////////////  DESCRIPTION EDITING  ////////////////////
    } else if (dataType === "description") {
        return (
          <FormGroup validationState={this.getValidationState()}>
            <FormControl
              componentClass="textarea"
              className="overview-input-field"
              type="text"
              value={this.state.editableText}
              onChange={this.handleChange}
            />
          </FormGroup>
        )
      ////////////////////  BUDGETED HOURS  ////////////////////
    } else if (dataType === "budgeted_hours") {
        return (
          <FormGroup
            validationState={this.getValidationState()}
            style={{width:"75%", display:"inline-block"}}
          >
            <FormControl
              className="short-description"
              type="number"
              min={0}
              step={0.25}
              value={this.state.editableText}
              onChange={this.handleChange}
            />
          </FormGroup>
        )
      ////////////////////  STATUS EDITING  ////////////////////
    } else if (dataType === "status") {
      return (
        <ButtonToolbar style={{width:"25%", display:"inline-block"}}>
          <DropdownButton
            bsSize="small"
            title={this.state.editableText}
            id="dropdown-size-small"
            onSelect={(e) => this.setState({editableText: e})}
          >
            <MenuItem eventKey="Active" className="Active">Active</MenuItem>
            <MenuItem eventKey="On Hold">On Hold</MenuItem>
            <MenuItem eventKey="Not Started">Not Started</MenuItem>
            <MenuItem eventKey="Completed">Completed</MenuItem>
          </DropdownButton>
        </ButtonToolbar>
      )
      ////////////////////  REGULATORY RELATED EDITING  ////////////////////
    } else if (dataType === "regulatory_related") {
      return (
        <ButtonToolbar style={{width:"25%", display:"inline-block"}}>
          <DropdownButton
            bsSize="small"
            title={this.state.editableText}
            id="dropdown-size-small"
            onSelect={(e) => this.setState({editableText: e})}
          >
            <MenuItem eventKey="No">No</MenuItem>
            <MenuItem eventKey="Yes">Yes</MenuItem>
          </DropdownButton>
        </ButtonToolbar>
      )
      ////////////////////  QC LEVEL EDITING  ////////////////////
    } else if (dataType === "start_date" || dataType === "completion_date" || dataType === 'target_end_date') {
      let datePickerValue = null
      if (this.state.editableText) {
        datePickerValue = this.generateFormattedDate(this.state.editableText)
      }

      return (
        <DatePicker
          value={datePickerValue}
          dateFormat="MM-DD-YYYY"
          weekStartsOn={1}
          style={{width:"120px", paddingBottom:"5px", display:"inline-block"}}
          onChange={(value, formattedValue) => this.setState({editableText: formattedValue})}
        />
      )
      ////////////////////  EDIT FIELDS FOR ALL TYPEAHEADS   ////////////////////
    } else if (dataType === 'metadata_values') {

      return (
        <MetadataOverviewField
          metadata={this.props.metadataType}
          editableText={this.state.editableText}
          editableArray={this.state.editableArray}
          _renderMenuItemChildren={this._renderMenuItemChildren}
          handleChange={this.handleChange}
          handleDateChange={this.handleDateChange}
          handleEditableArrayChange={this.handleEditableArrayChange}
          generateFormattedDate={this.generateFormattedDate}
        />
      )
    } else if (dataType === "project_leads" || dataType === "analysts") {
      return (
        <Typeahead
          id={ dataType }
          multiple
          labelKey={(user) => `${user.first_name} ${user.last_name}`}
          renderMenuItemChildren={this._renderMenuItemChildren}
          options={ this.props.users }
          selected={this.state.editableArray}
          onChange={(value) => this.setState({editableArray: value})}
        />
      )
    } else if (dataType === "proposals") {
      return (
        <Typeahead
          id={ dataType }
          multiple
          labelKey={this.props.renderProposalName}
          options={ this.props.clientProposals }
          selected={this.state.editableArray}
          onChange={(value) => this.setState({editableArray: value})}
        />
      )
    }
  }

  toggleEditAndViewModes = () => {
    /// RENDERS THE INFORMATION IN THE FIELD OR THAT FIELD'S EDIT FORM IF THE EDIT BUTTON WAS CLICKED
    if (this.state.editMode) {
      return this.renderEditForm()
    } else {
      if (this.props.dataType === 'proposals') {
        return this.props.text
      } else {
        return <span>{this.props.text}</span>
      }
    }
  }

  render () {
    const { currentUser } = this.props
    return (
      <div className="OverviewField">
        {this.toggleEditAndViewModes()}
        {currentUser.is_manager ? /// GIVES THE ABILITY TO EDIT A FIELD IF MANAGER
            this.state.editMode ?
              <span style={{float:"right"}}>
                <Button className="edit-icon" onClick={this.handleSaveClick}>
                  Save
                </Button>&nbsp;
                <Button className="edit-icon" onClick={this.handleCancelClick}>
                  Cancel
                </Button>&nbsp;&nbsp;
              </span>
              :
              <span style={{float:"right"}}>
                <Button className="edit-icon" onClick={this.handleEditClick}>
                  Edit
                </Button>&nbsp;&nbsp;
              </span>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
    users: state.manageLogin.users,
    clientProposals: state.manageProjects.clientProposals,
  }
}

export default connect(mapStateToProps)(OverviewField)



// WEBPACK FOOTER //
// ./src/routes/projects_project/components/OverviewField.js